// extracted by mini-css-extract-plugin
export default {"root":"_3EspL","prefix":"d8h2K","avatar":"_2QnuY"};